import * as Actions from '../../constant/ActionTypes';

const loadingServerLifecycleUpdateReducers = (response=false, action) => {
    switch(action.type) {
        case Actions.LOADING_UPDATE_SERVER_LIFE_CYCLE:           
            return action.payload;

        

        default :
        return response;
    }
}
export default loadingServerLifecycleUpdateReducers;